import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFairyweight,
  fetchPlasticAntweight,
  fetchAntweight,
  fetchBeetleweight,
  fetchHobbyweight,
  fetchFeatherweight,
  fetchSportsman,
  transformLessonData,
} from "../action/weightAction";

const initialState = {
  isLoading: false,
  fairyweightsList: [],
  plasticAntweightsList: [],
  antweightsList: [],
  beetleweightsList: [],
  hobbyweightsList: [],
  featherWeights30lbList: [],
  sportsmans30lbList: [],
};

const weightSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //"fetch-weight-fairyweight";
    builder.addCase(fetchFairyweight.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.fairyweightsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchFairyweight.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchFairyweight.rejected, (state, action) => {
      state.isLoading = false;
    });

    //"fetch-weight-plastic-antweight"
    builder.addCase(fetchPlasticAntweight.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.plasticAntweightsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchPlasticAntweight.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPlasticAntweight.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-weight-antweight"
    builder.addCase(fetchAntweight.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.antweightsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchAntweight.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAntweight.rejected, (state) => {
      state.isLoading = false;
    });

    // "fetch-weight-beetleweight"
    builder.addCase(fetchBeetleweight.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.beetleweightsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchBeetleweight.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBeetleweight.rejected, (state) => {
      state.isLoading = false;
    });

    // "fetch-weight-hobbyweight"
    builder.addCase(fetchHobbyweight.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.hobbyweightsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchHobbyweight.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHobbyweight.rejected, (state) => {
      state.isLoading = false;
    });

    // "fetch-weight-featherweight"
    builder.addCase(fetchFeatherweight.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.featherWeights30lbList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchFeatherweight.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchFeatherweight.rejected, (state) => {
      state.isLoading = false;
    });

    // "fetch-weight-sportsman"
    builder.addCase(fetchSportsman.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.sportsmans30lbList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchSportsman.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSportsman.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default weightSlice.reducer;
